// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__34FDC","header":"ReportDetails_header__38qvv","title":"ReportDetails_title___iBlX","left":"ReportDetails_left__30DVl"};